import config from './config.js'

export async function resendSignatureLink(etchPacketEid, formId, token) {
  try {
    const response = await fetch(`${config.apiBaseUrl}/resend/${etchPacketEid}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ formId })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error resending packet:', error);
    throw error;
  }
}